import type { StatusTone } from '@noor/ui';
import { dayjs } from '@noor/lib';

export type Translate = (key: string, fallback: string) => string;

export function lifecycleTone(status: string | null | undefined): StatusTone {
  switch ((status ?? '').toLowerCase()) {
    case 'life':
      return 'success';
    case 'created':
    case 'ready_for_life':
      return 'pending';
    case 'terminated':
      return 'danger';
    default:
      return 'neutral';
  }
}

export function lifecycleLabel(status: string | null | undefined, t: Translate): string {
  switch ((status ?? '').toLowerCase()) {
    case 'life':
      return t('lifecycle.life', 'Published');
    case 'created':
      return t('lifecycle.created', 'Draft');
    case 'ready_for_life':
      return t('lifecycle.readyForLife', 'On review');
    case 'terminated':
      return t('lifecycle.terminated', 'Terminated');
    default:
      return t('lifecycle.unknown', '—');
  }
}

export function activeTone(isActive: boolean | null | undefined): StatusTone {
  return isActive === false ? 'neutral' : 'success';
}

export function shortId(id: string | null | undefined): string {
  if (!id) return '—';
  return id.length > 8 ? `${id.slice(0, 8)}…` : id;
}

export function formatBusinessDate(value: string | null | undefined): string {
  if (!value) return '—';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('DD.MM.YYYY HH:mm') : '—';
}
